import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet, NavBarComponent, FooterComponent,LoadingComponent,CommonModule],
})
export class AppComponent {
  title = 'Auth0 Angular SDK Sample';

  isComponentVisible: boolean = false;
  
  receiveData(data: boolean) {
         this.isComponentVisible = data;
         console.log('Received data from child:', data);
       }

}
